import {
  USER_LOGIN, LOGIN_SUCCESS, LOGIN_ERROR, RESET_LOGIN,
} from './Actions';
import { initialState } from './UserContext';

const UserReducer = (state, action) => {
  switch (action.type) {
    case USER_LOGIN:
      return { ...state, status: 'loading' };
    case LOGIN_SUCCESS:
      localStorage.setItem('token', action.token);
      localStorage.setItem('user', JSON.stringify(action.user));
      return {
        ...state, user: action.user, token: action.token, status: 'success',
      };
    case LOGIN_ERROR:
      return { ...state, status: 'error', errorMessage: action.message };
    case RESET_LOGIN:
      return initialState;
    default:
      return state;
  }
};

export default UserReducer;
